<div id="wrapper" *ngIf="filteredPolicies$ | async as policyDefinitions">
<!--    entry fields for new policy-->
  <div class="container">
    <mat-form-field appearance="outline" class="search-form-field" color="accent">
      <mat-label>Search policies</mat-label>
      <input (input)="onSearch()" [(ngModel)]="searchText" matInput>
      <mat-icon matPrefix>search</mat-icon>
      <button (click)="searchText=''; onSearch()" *ngIf="searchText" mat-icon-button matSuffix>
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-paginator [length]="policyDefinitions?.length" hidePageSize="true" pageSize="10"></mat-paginator>

    <button (click)="onCreate()" color="accent" mat-stroked-button>
      <mat-icon>add_circle_outline</mat-icon>
      Create policy
    </button>

  </div>

  <div fxLayout="row wrap" fxLayoutAlign="start start">
    <mat-card *ngFor="let policyDef of policyDefinitions" class="policy-card">
      <mat-card-header>
        <mat-icon mat-card-avatar>policy</mat-icon>
        <mat-card-title><span class="code">{{policyDef.id}}</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <!-- deleted by nri 2025.2.10
        <mat-list dense>
          <mat-list-item>
            <mat-icon matListItemIcon>trip_origin</mat-icon>
            <div matListItemLine>{{policyDef.policy.optionalValue('odrl','assigner')}}</div>
            <div matListItemLine>Assigner</div>
          </mat-list-item>
          <mat-list-item>
            <mat-icon matListItemIcon>adjust</mat-icon>
            <div matListItemLine>{{policyDef.policy.optionalValue('odrl','assignee')}}</div>
            <div matListItemLine>Assignee</div>
          </mat-list-item>
        </mat-list>-->    
        <!-- Added by nri 2025.2.13 Start-->  
        <mat-list dense>
          <mat-list-item>
            <mat-icon matListItemIcon>adjust</mat-icon>
            <div matListItemTitle>Constraint</div>
            <div *ngFor="let permission of policyDef.policy.permissions">
              <div *ngFor='let con of permission.array("odrl","constraint")'>
                 <p *ngIf='dohandan(con["http://www.w3.org/ns/odrl/2/and"])'>
                  <span matListItemLine *ngFor='let aaa of con["http://www.w3.org/ns/odrl/2/and"]'>
                    {{processString(aaa["http://www.w3.org/ns/odrl/2/leftOperand"][0]["@id"])}}
                    {{" "}}
                    {{processString(aaa["http://www.w3.org/ns/odrl/2/operator"][0]["@id"])}}
                    {{" "}}
                    {{aaa["http://www.w3.org/ns/odrl/2/rightOperand"][0]["@value"]}}
                  </span>
                </p>
                <p *ngIf='!dohandan(con["http://www.w3.org/ns/odrl/2/and"])'>
                  <span matListItemLine>
                    {{ processString(con.nested('odrl','leftOperand')["@id"]) }} 
                    {{" "}}
                    {{ processString(con.nested('odrl','operator')["@id"]) }}
                    {{" "}}
                    {{ con.nested('odrl','rightOperand')["@value"] }}
                  </span>
                </p>
                </div>
            </div>
          </mat-list-item>
        </mat-list>
        <!-- Added by nri 2025.2.13 End-->  
        <!-- Permissions-->
        <!--
        <policy-rules *ngIf="policyDef.policy.permissions?.length != 0" [rules]="policyDef.policy.permissions" [title]="'Permissions'"></policy-rules>-->
        <!-- Obligations-->
        <policy-rules *ngIf="policyDef.policy.obligations?.length != 0" [rules]="policyDef.policy.obligations" [title]="'Obligations'"></policy-rules>
        <!-- Prohibitions-->
        <policy-rules *ngIf="policyDef.policy.prohibitions?.length != 0" [rules]="policyDef.policy.prohibitions" [title]="'Prohibitions'"></policy-rules>
        
      </mat-card-content>

      <mat-card-actions class="card-actions">
        <button (click)="delete(policyDef)" color="warn" mat-stroked-button>
          <mat-icon>delete_sweep</mat-icon> Delete
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
</div>
